import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import colors from '../assets/styles/variables/colors';

const HeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 16px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(10, 10, 15, 0.85);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid ${colors.border};
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
`;

const LogoMark = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, ${colors.accent}, ${colors.gold});
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 16px;
  color: #0a0a0f;
`;

const LogoText = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.text.light.very};
  letter-spacing: -0.5px;
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 32px;
`;

const NavLink = styled.a`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.text.light.little};
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: ${colors.text.light.very};
  }
`;

export default function Header() {
  const navigate = useNavigate();

  return (
    <HeaderWrapper>
      <Logo onClick={() => navigate('/')}>
        <LogoMark>TH</LogoMark>
        <LogoText>Tech Hackathon</LogoText>
      </Logo>
      <Nav>
        <NavLink onClick={() => navigate('/')}>Projects</NavLink>
        <NavLink href="#tech-stack">Stack</NavLink>
        <NavLink href="#evaluation">Evaluation</NavLink>
        <NavLink href="#submission">Submit</NavLink>
      </Nav>
    </HeaderWrapper>
  );
}
